import React, { useMemo } from 'react'
import moment from 'moment'

import BodyText from 'LuxKit/Typography/BodyText'
import BedbankCancellationPolicy from './BedbankCancellationPolicy'
import BedbankPromotionCancellationPolicy from 'components/OfferPage/Bedbank/BedbankPromotionCancellationPolicy'
import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'
import { pluralizeToString } from 'lib/string/pluralize'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  checkInDate?: string
  checkOutDate?: string
  onlySalePeriod?: boolean
  promotion: App.BedbankPromotion
  rate?: App.BedbankRate | App.OrderBedbankRate
  showNonCancellation?: boolean
}

function BedbankPromotionDetails(props: Props) {
  const {
    checkInDate,
    checkOutDate,
    onlySalePeriod,
    promotion,
    rate,
    showNonCancellation,
  } = props

  const validCheckInCheckoutDates = !!(checkInDate && checkOutDate)

  const [fromDate, toDate] = useMemo(() => ([moment(promotion.travelPeriod.from), moment(promotion.travelPeriod.to)]), [promotion])

  return <VerticalSpacer gap={8}>
    {rate && <BedbankCancellationPolicy
      rate={rate}
      showNonCancellation={!!showNonCancellation}
    />}
    {!validCheckInCheckoutDates && promotion.cancellationPolicy && <BedbankPromotionCancellationPolicy
      policyCode={promotion.cancellationPolicy}
    />}
    {!onlySalePeriod && <div>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        Travel between <FormatDateTimeRange startValue={fromDate} endValue={toDate} format="dmy-casual" />
      </BodyText>
      <BodyText variant="medium" weight="normal" colour="neutral-two">
        Min stay: {pluralizeToString('night', promotion.los)}
      </BodyText>
    </div>}
  </VerticalSpacer>
}

export default BedbankPromotionDetails
